// import { FC } from 'react';
// import { Modal } from 'react-bootstrap';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }



// export const KycDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {




//     const getGstCertificateUrl = () => {
//         const gstDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'GST_CERTIFICATE'
//         );
//         return gstDoc?.docUrl || null;
//     };

//     const getPanUrl = () => {
//         const panDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'PAN'
//         );
//         return panDoc?.docUrl || null;
//     };

//     const getMsmeUrl = () => {
//         const msmeDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'MSME_CERTIFICATE'
//         );
//         return msmeDoc?.docUrl || null;
//     };
//     const getAadharNumber = () => {
//         const aadharDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'AADHAR'
//         );
//         return aadharDoc?.docNumber || 'N/A';
//     };

//     const getPanNumber = () => {
//         const panDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'PAN'
//         );
//         return panDoc?.docNumber || 'N/A';
//     };

//     const getGstNumber = () => {
//         const gstDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'GST_CERTIFICATE'
//         );
//         return gstDoc?.docNumber || 'N/A';
//     };

//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">KYC Details</h1>
//                     </div>

//                     <div className="table-responsive">
//                         <table style={{
//                             width: '100%',
//                             borderCollapse: 'collapse',
//                             marginBottom: '20px',
//                             tableLayout: 'fixed' // This helps maintain consistent column widths
//                         }}>
//                             <thead>
//                                 <tr className="fw-bold  bg-light">
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Aadhar</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>PAN</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>GST</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getAadharNumber()}
//                                         </span>
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getPanNumber()}
//                                         </span>
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getGstNumber()}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>





//                     {/* Document Images Section */}
//                     <div className="mt-5">
//                         {/* <h3 className="mb-4">Document Images</h3> */}
//                         <div className="row">
//                             {/* GST Certificate */}
//                             <div className="col-md-4 mb-4">
//                                 <div className="card">
//                                     <div className="card-header">
//                                         <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
//                                             GST Certificate
//                                         </p>
//                                     </div>
//                                     <div className="card-body text-center">
//                                         {getGstCertificateUrl() ? (
//                                             <img
//                                                 src={getGstCertificateUrl()}
//                                                 alt="GST Certificate"
//                                                 style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
//                                                 className="img-fluid cursor-pointer"
//                                                 onClick={() => window.open(getGstCertificateUrl(), '_blank')}
//                                             />
//                                         ) : (
//                                             <div className="text-muted">No image available</div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* PAN Document */}
//                             <div className="col-md-4 mb-4">
//                                 <div className="card">
//                                     <div className="card-header">
//                                         {/* <h6 className="mb-0"></h6> */}
//                                         <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
//                                             PAN Document
//                                         </p>
//                                     </div>
//                                     <div className="card-body text-center">
//                                         {getPanUrl() ? (
//                                             <img
//                                                 src={getPanUrl()}
//                                                 alt="PAN Document"
//                                                 style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
//                                                 className="img-fluid cursor-pointer"
//                                                 onClick={() => window.open(getPanUrl(), '_blank')}
//                                             />
//                                         ) : (
//                                             <div className="text-muted">No image available</div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* MSME Certificate */}
//                             <div className="col-md-4 mb-4">
//                                 <div className="card">
//                                     <div className="card-header">
//                                         {/* <h6 className="mb-0">MSME Certificate</h6> */}
//                                         <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
//                                             MSME Certificate
//                                         </p>

//                                     </div>
//                                     <div className="card-body text-center">
//                                         {getMsmeUrl() ? (
//                                             <img
//                                                 src={getMsmeUrl()}
//                                                 alt="MSME Certificate"
//                                                 style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
//                                                 className="img-fluid cursor-pointer"
//                                                 onClick={() => window.open(getMsmeUrl(), '_blank')}
//                                             />
//                                         ) : (
//                                             <div className="text-muted">No image available</div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>




//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={onClose}
//                         >
//                             Close
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };








// import { FC, useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import { useAuth } from '../../../../../auth';
// import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload';
// import { useFormik } from 'formik';
// import { useLocation } from 'react-router-dom';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const KycDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {
//     const { currentUser } = useAuth();
//     const isAdmin = (currentUser as any)?.role?.name === "ADMIN_CXO";
//     const location = useLocation();
//     const isRecyclerPath = location.pathname.includes('/apps/business/recycler');
//     const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point');
//     const canEdit = isAdmin && (isRecyclerPath || isCollectionPointPath);

//     const [kycFields, setKycFields] = useState({
//         aadharNumber: '',
//         panNumber: '',
//         gstNumber: '',
//         gstCertificateUrl: '',
//         panUrl: ''
//     });

//     const [originalFields, setOriginalFields] = useState({
//         aadharNumber: '',
//         panNumber: '',
//         gstNumber: '',
//         gstCertificateUrl: '',
//         panUrl: ''
//     });

//     const [hasChanges, setHasChanges] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);

//     const formik = useFormik({
//         initialValues: {
//             gstCertificate: kycFields.gstCertificateUrl,
//             panDocument: kycFields.panUrl
//         },
//         onSubmit: () => { },
//         enableReinitialize: true
//     });

//     useEffect(() => {
//         formik.setFieldValue('gstCertificate', kycFields.gstCertificateUrl);
//         formik.setFieldValue('panDocument', kycFields.panUrl);
//     }, [kycFields]);

//     // Initialize fields when user data changes
//     useEffect(() => {
//         if (user?.kycDocument) {
//             const panDoc = user.kycDocument.find((doc: any) => doc?.docType === 'PAN');
//             const gstDoc = user.kycDocument.find((doc: any) => doc?.docType === 'GST_CERTIFICATE');
//             const aadharDoc = user.kycDocument.find((doc: any) => doc?.docType === 'AADHAR');

//             const initialFields = {
//                 aadharNumber: aadharDoc?.docNumber || '',
//                 panNumber: panDoc?.docNumber || '',
//                 gstNumber: gstDoc?.docNumber || '',
//                 gstCertificateUrl: gstDoc?.docUrl || '',
//                 panUrl: panDoc?.docUrl || ''
//             };
//             setKycFields(initialFields);
//             setOriginalFields(initialFields);
//         }
//     }, [user]);

//     // Check for changes
//     useEffect(() => {
//         const fieldsChanged = Object.keys(kycFields).some(
//             key => kycFields[key as keyof typeof kycFields] !== originalFields[key as keyof typeof originalFields]
//         );

//         // Also check if images were uploaded
//         const imagesChanged =
//             formik.values.gstCertificate !== (user?.kycDocument?.find((doc: any) => doc?.docType === 'GST_CERTIFICATE')?.docUrl || '') ||
//             formik.values.panDocument !== (user?.kycDocument?.find((doc: any) => doc?.docType === 'PAN')?.docUrl || '');

//         setHasChanges(fieldsChanged || imagesChanged);
//     }, [kycFields, originalFields, formik.values]);

//     const handleFieldChange = (field: keyof typeof kycFields, value: string) => {
//         setKycFields(prev => ({
//             ...prev,
//             [field]: value
//         }));

//         // Update formik values for image fields
//         if (field === 'gstCertificateUrl') {
//             formik.setFieldValue('gstCertificate', value);
//         } else if (field === 'panUrl') {
//             formik.setFieldValue('panDocument', value);
//         }
//     };

//     const handleSave = async () => {
//         if (!hasChanges || !user?.id) return;
//         setIsLoading(true);
//         try {
//             let updatedPayload;
//             if (isRecyclerPath) {
//                 updatedPayload = {
//                     firstName: user.personalDetails?.name || "",
//                     email: user.personalDetails?.email || "",
//                     mobile: user.personalDetails?.mobile || "",
//                     userType: "RECYCLER",
//                     countryCode: "91",
//                     franchiseId: "",
//                     status: "ACTIVE",
//                     kycDocument: [
//                         {
//                             docUrl: user.kycDocument?.find((doc: any) => doc?.docType === 'AADHAR')?.docUrl || "",
//                             docNumber: kycFields.aadharNumber,
//                             docType: "AADHAR"
//                         },
//                         {
//                             docUrl: formik.values.gstCertificate,
//                             docNumber: kycFields.gstNumber,
//                             docType: "GST_CERTIFICATE"
//                         },
//                         {
//                             docUrl: formik.values.panDocument,
//                             docNumber: kycFields.panNumber,
//                             docType: "PAN"
//                         },
//                         {
//                             docUrl: user.kycDocument?.find((doc: any) => doc?.docType === 'MSME_CERTIFICATE')?.docUrl || "",
//                             docNumber: user.kycDocument?.find((doc: any) => doc?.docType === 'MSME_CERTIFICATE')?.docNumber || "",
//                             docType: "MSME_CERTIFICATE"
//                         }
//                     ],
//                     companyDetails: {
//                         name: user.companyDetails?.name || "",
//                         companyId: user.companyDetails?.companyId || "",
//                     },
//                     address: [
//                         {
//                             addressType: "OFFICE_ADDRESS",
//                             city: user.address?.city,
//                             state: user.address?.state,
//                             country: user.address?.country,
//                             zipCode: user.address?.zipCode,
//                             street: user.address?.street,
//                             latitute: user.address?.[0]?.latitute || 0,
//                             longitute: user.address?.[0]?.longitute || 0,
//                         }
//                     ],
//                     bankDetails: {
//                         bankName: user.bankDetails?.bankName || "",
//                         accountNo: user.bankDetails?.accountNo || "",
//                         ifscCode: user.bankDetails?.ifscCode || "",
//                         accountName: user.bankDetails?.accountName || "",
//                         images: [
//                             {
//                                 docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
//                                 docType: "CANCEL_CHEQUE"
//                             }
//                         ]
//                     }
//                 };
//             } else {
//                 // Collection point payload
//                 updatedPayload = {
//                     pickupPointStaffId: user.pickupPointStaffId,
//                     pickupPointStaffName: user.pickupPointStaffName,
//                     firstName: user.personalDetails?.name || "",
//                     email: user.personalDetails?.email || "",
//                     mobile: user.personalDetails?.mobile || "",
//                     userType: "PICKUP_POINT",
//                     countryCode: "91",
//                     franchiseId: user.franchiseId || "",
//                     status: "ACTIVE",
//                     kycDocument: [
//                         {
//                             docUrl: user.kycDocument?.find((doc: any) => doc?.docType === 'CIN')?.docUrl || "",
//                             docNumber: user.kycDocument?.find((doc: any) => doc?.docType === 'CIN')?.docNumber || "",
//                             docType: "CIN"
//                         },
//                         {
//                             docUrl: user.kycDocument?.find((doc: any) => doc?.docType === 'AADHAR')?.docUrl || "",
//                             docNumber: kycFields.aadharNumber,
//                             docType: "AADHAR"
//                         },
//                         {
//                             docUrl: formik.values.gstCertificate,
//                             docNumber: kycFields.gstNumber,
//                             docType: "GST_NUMBER"
//                         },
//                         {
//                             docUrl: formik.values.panDocument,
//                             docNumber: kycFields.panNumber,
//                             docType: "PAN"
//                         }
//                     ],
//                     companyDetails: {
//                         name: user.companyDetails?.name || "",
//                         companyId: user.companyDetails?.companyId || ""
//                     },
//                     address: [
//                         {
//                             addressType: "OFFICE_ADDRESS",
//                             street: user.address?.[0]?.street || "",
//                             city: user.address?.[0]?.city || "",
//                             zipCode: user.address?.[0]?.zipCode || "",
//                             country: user.address?.[0]?.country || "India",
//                             state: user.address?.[0]?.state || ""
//                         }
//                     ],
//                     bankDetails: {
//                         bankName: user.bankDetails?.bankName || "",
//                         accountNo: user.bankDetails?.accountNo || "",
//                         ifscCode: user.bankDetails?.ifscCode || "",
//                         accountName: user.bankDetails?.accountName || "",
//                         images: [
//                             {
//                                 docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
//                                 docType: "CANCEL_CHEQUE"
//                             }
//                         ]
//                     }
//                 };
//             }

//             const response = await fetch(`https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`, {
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(updatedPayload)
//             });

//             if (!response.ok) {
//                 throw new Error('Failed to update user');
//             }
//             setOriginalFields(kycFields);
//             setHasChanges(false);
//         } catch (error) {
//             console.error('Error updating user:', error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleClose = () => {
//         setKycFields(originalFields);
//         setHasChanges(false);
//         onClose();
//     };

//     const getGstCertificateUrl = () => {
//         const gstDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'GST_CERTIFICATE'
//         );
//         return gstDoc?.docUrl || null;
//     };

//     const getPanUrl = () => {
//         const panDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'PAN'
//         );
//         return panDoc?.docUrl || null;
//     };

//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
//                         ×
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">KYC Details</h1>
//                     </div>

//                     <div className="table-responsive">
//                         <table style={{
//                             width: '100%',
//                             borderCollapse: 'collapse',
//                             marginBottom: '20px',
//                             tableLayout: 'fixed'
//                         }}>
//                             <thead>
//                                 <tr className="fw-bold bg-light">
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Aadhar</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>PAN</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>GST</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         {canEdit ? (
//                                             <input
//                                                 type="text"
//                                                 value={kycFields.aadharNumber}
//                                                 onChange={(e) => handleFieldChange('aadharNumber', e.target.value)}
//                                                 style={{
//                                                     width: "100%",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                     padding: "8px",
//                                                     fontSize: "14px"
//                                                 }}
//                                                 placeholder="Enter Aadhar number"
//                                             />
//                                         ) : (
//                                             <span className="text-dark fw-semibold d-block fs-6">
//                                                 {kycFields.aadharNumber || 'N/A'}
//                                             </span>
//                                         )}
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         {canEdit ? (
//                                             <input
//                                                 type="text"
//                                                 value={kycFields.panNumber}
//                                                 onChange={(e) => handleFieldChange('panNumber', e.target.value)}
//                                                 style={{
//                                                     width: "100%",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                     padding: "8px",
//                                                     fontSize: "14px"
//                                                 }}
//                                                 placeholder="Enter PAN number"
//                                             />
//                                         ) : (
//                                             <span className="text-dark fw-semibold d-block fs-6">
//                                                 {kycFields.panNumber || 'N/A'}
//                                             </span>
//                                         )}
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         {canEdit ? (
//                                             <input
//                                                 type="text"
//                                                 value={kycFields.gstNumber}
//                                                 onChange={(e) => handleFieldChange('gstNumber', e.target.value)}
//                                                 style={{
//                                                     width: "100%",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                     padding: "8px",
//                                                     fontSize: "14px"
//                                                 }}
//                                                 placeholder="Enter GST number"
//                                             />
//                                         ) : (
//                                             <span className="text-dark fw-semibold d-block fs-6">
//                                                 {kycFields.gstNumber || 'N/A'}
//                                             </span>
//                                         )}
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* Document Images Section */}
//                     <div className="mt-5">
//                         <div className="row">
//                             {/* GST Certificate */}
//                             <div className="col-md-4 mb-4">
//                                 <div className="card">
//                                     <div className="card-header">
//                                         <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
//                                             GST Certificate
//                                         </p>
//                                     </div>
//                                     <div className="card-body text-center">
//                                         {canEdit ? (
//                                             <UploadImage name='gstCertificate' formik={formik} label='Upload GST Certificate' />
//                                         ) : (
//                                             getGstCertificateUrl() ? (
//                                                 <img
//                                                     src={getGstCertificateUrl()}
//                                                     alt="GST Certificate"
//                                                     style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
//                                                     className="img-fluid cursor-pointer"
//                                                     onClick={() => window.open(getGstCertificateUrl(), '_blank')}
//                                                 />
//                                             ) : (
//                                                 <div className="text-muted">No image available</div>
//                                             )
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* PAN Document */}
//                             <div className="col-md-4 mb-4">
//                                 <div className="card">
//                                     <div className="card-header">
//                                         <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
//                                             PAN Document
//                                         </p>
//                                     </div>
//                                     <div className="card-body text-center">
//                                         {canEdit ? (
//                                             <UploadImage name='panDocument' formik={formik} label='Upload PAN Document' />
//                                         ) : (
//                                             getPanUrl() ? (
//                                                 <img
//                                                     src={getPanUrl()}
//                                                     alt="PAN Document"
//                                                     style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
//                                                     className="img-fluid cursor-pointer"
//                                                     onClick={() => window.open(getPanUrl(), '_blank')}
//                                                 />
//                                             ) : (
//                                                 <div className="text-muted">No image available</div>
//                                             )
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* MSME Certificate */}
//                             <div className="col-md-4 mb-4">
//                                 <div className="card">
//                                     <div className="card-header">
//                                         <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
//                                             MSME Certificate
//                                         </p>
//                                     </div>
//                                     <div className="card-body text-center">
//                                         <div className="text-muted">No image available</div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={handleClose}
//                         >
//                             Close
//                         </button>
//                         {canEdit && (
//                             <button
//                                 type="button"
//                                 className={`btn ${hasChanges ? 'btn-primary' : 'btn-secondary'}`}
//                                 onClick={handleSave}
//                                 disabled={!hasChanges || isLoading}
//                                 style={{
//                                     marginLeft: "10px",
//                                     opacity: hasChanges ? 1 : 0.6,
//                                     cursor: hasChanges ? 'pointer' : 'not-allowed'
//                                 }}
//                             >
//                                 {isLoading ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };

















import { FC, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../../../../auth';
import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload';
import { useFormik } from 'formik';
import { useLocation } from 'react-router-dom';
// import { successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const KycDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const { currentUser } = useAuth();
    const isAdmin = (currentUser as any)?.role?.name === "ADMIN_CXO";
    const location = useLocation();
    const isRecyclerPath = location.pathname.includes('/apps/business/recycler');
    const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler');
    const isCollectionPointPathFinance = location.pathname.includes('/apps/finance/collection-point');
    const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point');

    // const canEdit = isAdmin && (isRecyclerPath || isCollectionPointPath);
    const canEdit = isAdmin && (isRecyclerPath || isRecyclerPathFinance || isCollectionPointPath || isCollectionPointPathFinance);

    const [kycFields, setKycFields] = useState({
        aadharNumber: '',
        panNumber: '',
        gstNumber: '',
        gstCertificateUrl: '',
        panUrl: '',
        msmeUrl: ''
    });

    const [originalFields, setOriginalFields] = useState({
        aadharNumber: '',
        panNumber: '',
        gstNumber: '',
        gstCertificateUrl: '',
        panUrl: '',
        msmeUrl: ''
    });

    const [hasChanges, setHasChanges] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            gstCertificate: kycFields.gstCertificateUrl,
            panDocument: kycFields.panUrl,
            msmeCertificate: kycFields.msmeUrl
        },
        onSubmit: () => { },
        enableReinitialize: true
    });

    useEffect(() => {
        formik.setFieldValue('gstCertificate', kycFields.gstCertificateUrl);
        formik.setFieldValue('panDocument', kycFields.panUrl);
        formik.setFieldValue('msmeCertificate', kycFields.msmeUrl);
    }, [kycFields]);

    // Initialize fields when user data changes
    useEffect(() => {
        if (user?.kycDocument) {
            const panDoc = user.kycDocument.find((doc: any) => doc?.docType === 'PAN');
            const gstDoc = user.kycDocument.find((doc: any) => doc?.docType === 'GST_CERTIFICATE');
            const aadharDoc = user.kycDocument.find((doc: any) => doc?.docType === 'AADHAR');
            const msmeDoc = user.kycDocument.find((doc: any) => doc?.docType === 'MSME_CERTIFICATE');

            const initialFields = {
                aadharNumber: aadharDoc?.docNumber || '',
                panNumber: panDoc?.docNumber || '',
                gstNumber: gstDoc?.docNumber || '',
                gstCertificateUrl: gstDoc?.docUrl || '',
                panUrl: panDoc?.docUrl || '',
                msmeUrl: msmeDoc?.docUrl || ''
            };
            setKycFields(initialFields);
            setOriginalFields(initialFields);
        }
    }, [user]);

    // Check for changes
    useEffect(() => {
        const fieldsChanged = Object.keys(kycFields).some(
            key => kycFields[key as keyof typeof kycFields] !== originalFields[key as keyof typeof originalFields]
        );

        // Also check if images were uploaded
        const imagesChanged =
            formik.values.gstCertificate !== (user?.kycDocument?.find((doc: any) => doc?.docType === 'GST_CERTIFICATE')?.docUrl || '') ||
            formik.values.panDocument !== (user?.kycDocument?.find((doc: any) => doc?.docType === 'PAN')?.docUrl || '') ||
            formik.values.msmeCertificate !== (user?.kycDocument?.find((doc: any) => doc?.docType === 'MSME_CERTIFICATE')?.docUrl || '');

        setHasChanges(fieldsChanged || imagesChanged);
    }, [kycFields, originalFields, formik.values]);

    const handleFieldChange = (field: keyof typeof kycFields, value: string) => {
        setKycFields(prev => ({
            ...prev,
            [field]: value
        }));

        // Update formik values for image fields
        if (field === 'gstCertificateUrl') {
            formik.setFieldValue('gstCertificate', value);
        } else if (field === 'panUrl') {
            formik.setFieldValue('panDocument', value);
        } else if (field === 'msmeUrl') {
            formik.setFieldValue('msmeCertificate', value);
        }
    };

    const handleSave = async () => {
        if (!hasChanges || !user?.id) return;
        setIsLoading(true);
        try {
            let updatedPayload;
            if (isRecyclerPath || isRecyclerPathFinance) {
                updatedPayload = {
                    firstName: user.personalDetails?.name || "",
                    email: user.personalDetails?.email || "",
                    mobile: user.personalDetails?.mobile || "",
                    userType: "RECYCLER",
                    countryCode: "91",
                    franchiseId: "",
                    status: "ACTIVE",
                    kycDocument: [
                        {
                            docUrl: user.kycDocument?.find((doc: any) => doc?.docType === 'AADHAR')?.docUrl || "",
                            docNumber: kycFields.aadharNumber,
                            docType: "AADHAR"
                        },
                        {
                            docUrl: formik.values.gstCertificate,
                            docNumber: kycFields.gstNumber,
                            docType: "GST_CERTIFICATE"
                        },
                        {
                            docUrl: formik.values.panDocument,
                            docNumber: kycFields.panNumber,
                            docType: "PAN"
                        },
                        {
                            docUrl: formik.values.msmeCertificate,
                            docNumber: user.kycDocument?.find((doc: any) => doc?.docType === 'MSME_CERTIFICATE')?.docNumber || "",
                            docType: "MSME_CERTIFICATE"
                        }
                    ],
                    companyDetails: {
                        name: user.companyDetails?.name || "",
                        companyId: user.companyDetails?.companyId || "",
                    },
                    address: [
                        {
                            addressType: "OFFICE_ADDRESS",
                            city: user.address?.city,
                            state: user.address?.state,
                            country: user.address?.country,
                            zipCode: user.address?.zipCode,
                            street: user.address?.street,
                            latitute: user.address?.[0]?.latitute || 0,
                            longitute: user.address?.[0]?.longitute || 0,
                        }
                    ],
                    bankDetails: {
                        bankName: user.bankDetails?.bankName || "",
                        accountNo: user.bankDetails?.accountNo || "",
                        ifscCode: user.bankDetails?.ifscCode || "",
                        accountName: user.bankDetails?.accountName || "",
                        images: [
                            {
                                docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
                                docType: "CANCEL_CHEQUE"
                            }
                        ]
                    }
                };
            } else {
                // Collection point payload
                updatedPayload = {
                    pickupPointStaffId: user.pickupPointStaffId,
                    pickupPointStaffName: user.pickupPointStaffName,
                    firstName: user.personalDetails?.name || "",
                    email: user.personalDetails?.email || "",
                    mobile: user.personalDetails?.mobile || "",
                    userType: "PICKUP_POINT",
                    countryCode: "91",
                    franchiseId: user.franchiseId || "",
                    status: "ACTIVE",
                    kycDocument: [
                        {
                            docUrl: user.kycDocument?.find((doc: any) => doc?.docType === 'CIN')?.docUrl || "",
                            docNumber: user.kycDocument?.find((doc: any) => doc?.docType === 'CIN')?.docNumber || "",
                            docType: "CIN"
                        },
                        {
                            docUrl: user.kycDocument?.find((doc: any) => doc?.docType === 'AADHAR')?.docUrl || "",
                            docNumber: kycFields.aadharNumber,
                            docType: "AADHAR"
                        },
                        {
                            docUrl: formik.values.gstCertificate,
                            docNumber: kycFields.gstNumber,
                            docType: "GST_NUMBER"
                        },
                        {
                            docUrl: formik.values.panDocument,
                            docNumber: kycFields.panNumber,
                            docType: "PAN"
                        }
                    ],
                    companyDetails: {
                        name: user.companyDetails?.name || "",
                        companyId: user.companyDetails?.companyId || ""
                    },
                    address: [
                        {
                            addressType: "OFFICE_ADDRESS",
                            street: user.address?.[0]?.street || "",
                            city: user.address?.[0]?.city || "",
                            zipCode: user.address?.[0]?.zipCode || "",
                            country: user.address?.[0]?.country || "India",
                            state: user.address?.[0]?.state || ""
                        }
                    ],
                    bankDetails: {
                        bankName: user.bankDetails?.bankName || "",
                        accountNo: user.bankDetails?.accountNo || "",
                        ifscCode: user.bankDetails?.ifscCode || "",
                        accountName: user.bankDetails?.accountName || "",
                        images: [
                            {
                                docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
                                docType: "CANCEL_CHEQUE"
                            }
                        ]
                    }
                };
            }

            const response = await fetch(`https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedPayload)
            });

            if (!response.ok) {
                throw new Error('Failed to update user');
            }
            console.log('About to show success toast'); // Debug line
            successToast('Modified');
            console.log('Success toast called'); // Debug line
            setOriginalFields(kycFields);
            setHasChanges(false);
        } catch (error) {
            console.error('Error updating user:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setKycFields(originalFields);
        setHasChanges(false);
        onClose();
    };

    const getGstCertificateUrl = () => {
        const gstDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'GST_CERTIFICATE'
        );
        return gstDoc?.docUrl || null;
    };

    const getPanUrl = () => {
        const panDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'PAN'
        );
        return panDoc?.docUrl || null;
    };

    const getMsmeUrl = () => {
        const msmeDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'MSME_CERTIFICATE'
        );
        return msmeDoc?.docUrl || null;
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
                        ×
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">KYC Details</h1>
                    </div>

                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Aadhar</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>PAN</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>GST</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {canEdit ? (
                                            <input
                                                type="text"
                                                value={kycFields.aadharNumber}
                                                onChange={(e) => handleFieldChange('aadharNumber', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    border: kycFields.aadharNumber === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    fontSize: "14px"
                                                }}
                                                placeholder="Enter Aadhar number"
                                            />
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {kycFields.aadharNumber || 'N/A'}
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {canEdit ? (
                                            <input
                                                type="text"
                                                value={kycFields.panNumber}
                                                onChange={(e) => handleFieldChange('panNumber', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    border: kycFields.panNumber === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    fontSize: "14px"
                                                }}
                                                placeholder="Enter PAN number"
                                            />
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {kycFields.panNumber || 'N/A'}
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {canEdit ? (
                                            <input
                                                type="text"
                                                value={kycFields.gstNumber}
                                                onChange={(e) => handleFieldChange('gstNumber', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    border: kycFields.gstNumber === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    fontSize: "14px"
                                                }}
                                                placeholder="Enter GST number"
                                            />
                                        ) : (
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {kycFields.gstNumber || 'N/A'}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Document Images Section */}
                    <div className="mt-5">
                        <div className="row">
                            {/* GST Certificate */}
                            <div className="col-md-4 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
                                            GST Certificate
                                        </p>
                                    </div>
                                    <div className="card-body text-center">
                                        {canEdit ? (
                                            <UploadImage name='gstCertificate' formik={formik} label='' />
                                        ) : (
                                            getGstCertificateUrl() ? (
                                                <img
                                                    src={getGstCertificateUrl()}
                                                    alt="GST Certificate"
                                                    style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
                                                    className="img-fluid cursor-pointer"
                                                    onClick={() => window.open(getGstCertificateUrl(), '_blank')}
                                                />
                                            ) : (
                                                <div className="text-muted">No image available</div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* PAN Document */}
                            <div className="col-md-4 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
                                            PAN Document
                                        </p>
                                    </div>
                                    <div className="card-body text-center">
                                        {canEdit ? (
                                            <UploadImage name='panDocument' formik={formik} label='' />
                                        ) : (
                                            getPanUrl() ? (
                                                <img
                                                    src={getPanUrl()}
                                                    alt="PAN Document"
                                                    style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
                                                    className="img-fluid cursor-pointer"
                                                    onClick={() => window.open(getPanUrl(), '_blank')}
                                                />
                                            ) : (
                                                <div className="text-muted">No image available</div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* MSME Certificate */}
                            <div className="col-md-4 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
                                            MSME Certificate
                                        </p>
                                    </div>
                                    <div className="card-body text-center">
                                        {canEdit ? (
                                            <UploadImage name='msmeCertificate' formik={formik} label='' />
                                        ) : (
                                            getMsmeUrl() ? (
                                                <img
                                                    src={getMsmeUrl()}
                                                    alt="MSME Certificate"
                                                    style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
                                                    className="img-fluid cursor-pointer"
                                                    onClick={() => window.open(getMsmeUrl(), '_blank')}
                                                />
                                            ) : (
                                                <div className="text-muted">No image available</div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                        {canEdit && (
                            <button
                                type="button"
                                className={`btn ${hasChanges ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={handleSave}
                                disabled={!hasChanges || isLoading}
                                style={{
                                    marginLeft: "10px",
                                    opacity: hasChanges ? 1 : 0.6,
                                    cursor: hasChanges ? 'pointer' : 'not-allowed'
                                }}
                            >
                                {isLoading ? 'Saving...' : 'Save Changes'}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};